import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';
import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { toast } from 'sonner';
import { Users, Building2 } from 'lucide-react';

export default function Teams() {
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { axiosInstance } = useAuth();

  useEffect(() => {
    fetchTeams();
    fetchUsers();
  }, []);

  const fetchTeams = async () => {
    try {
      const response = await axiosInstance.get('/teams');
      setTeams(response.data);
    } catch (error) {
      toast.error('Échec du chargement des équipes');
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axiosInstance.get('/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Failed to fetch users');
    }
  };

  const getUserName = (userId) => {
    const user = users.find(u => u.id === userId);
    return user ? `${user.first_name} ${user.last_name}` : 'Inconnu';
  };

  if (loading) {
    return (
      <Layout title="Équipes">
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="Équipes">
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="teams-grid">
          {teams.length === 0 ? (
            <Card className="glass-card border-amber-200 col-span-full">
              <CardContent className="py-12 text-center text-gray-500">
                Aucune équipe trouvée
              </CardContent>
            </Card>
          ) : (
            teams.map((team) => (
              <Card key={team.id} className="glass-card border-amber-200" data-testid={`team-card-${team.id}`}>
                <CardHeader>
                  <CardTitle className="flex items-center text-amber-900">
                    <Users className="mr-2" size={24} />
                    <span data-testid={`team-name-${team.id}`}>{team.name}</span>
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <p className="text-sm font-semibold text-gray-700 mb-1">Référent</p>
                    <Badge className="bg-amber-500 text-white">
                      {getUserName(team.referent_user_id)}
                    </Badge>
                  </div>
                  
                  <div>
                    <p className="text-sm font-semibold text-gray-700 mb-2">Membres ({team.members.length})</p>
                    <div className="space-y-1">
                      {team.members.map((memberId) => (
                        <div key={memberId} className="text-sm text-gray-600 bg-white p-2 rounded border border-amber-200">
                          {getUserName(memberId)}
                        </div>
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      </div>
    </Layout>
  );
}